import './ServiceTypes.css';

const img = (name) => `${process.env.PUBLIC_URL}/images/optimized/${name}`;

const ServiceTypes = () => {
  const services = [
    {
      image: img('evento-corporativo-led-palco-800.webp'),
      icon: 'fas fa-briefcase',
      title: 'Eventos Corporativos',
      description: 'Painéis de LED para convenções, lançamentos de produtos, palestras e treinamentos. Transmita profissionalismo e impacte sua audiência com visuais de alta definição.',
      features: ['Apresentações em alta resolução', 'Transmissão ao vivo', 'Cenários personalizados'],
      alt: 'Painel de LED exibindo apresentação em evento corporativo com palestrantes no palco'
    },
    {
      image: img('festival-led-noite-800.webp'),
      icon: 'fas fa-music',
      title: 'Shows e Festivais',
      description: 'Telões de LED que amplificam a energia do seu show. Visibilidade perfeita para grandes públicos em qualquer condição de luz.',
      features: ['Telões de grande formato', 'Alta taxa de atualização', 'Resistência outdoor IP65'],
      alt: 'Festival de música noturno com painéis de LED coloridos iluminando o palco e a multidão'
    },
    {
      image: img('festival-led-geometrico-800.webp'),
      icon: 'fas fa-glass-cheers',
      title: 'Festas e Casamentos',
      description: 'Painéis de LED decorativos que criam ambientes únicos. Projete fotos, vídeos e mensagens especiais para seus convidados.',
      features: ['Painéis decorativos', 'Projeção de conteúdo', 'Iluminação cênica'],
      alt: 'Painel de LED decorativo em festa com iluminação cênica e efeitos visuais'
    },
    {
      image: img('shopping-led-horizontal-800.webp'),
      icon: 'fas fa-store',
      title: 'Shoppings e Varejo',
      description: 'Painéis e totens de LED para shopping centers: publicidade, sinalização digital, decoração sazonal e comunicação visual de alto impacto.',
      features: ['Totens verticais e horizontais', 'Conteúdo dinâmico programável', 'Alta visibilidade'],
      alt: 'Grande painel de LED horizontal em corredor de shopping center moderno'
    },
    {
      image: img('igreja-conferencia-led-800.webp'),
      icon: 'fas fa-church',
      title: 'Igrejas e Eventos Religiosos',
      description: 'Telões de LED para cultos, conferências e eventos religiosos. Amplie a experiência da congregação com visuais de alta definição.',
      features: ['Telões para cultos ao vivo', 'Projeção de letras e vídeos', 'Instalação temporária ou fixa'],
      alt: 'Telão de LED em conferência religiosa exibindo conteúdo para a congregação'
    },
    {
      image: img('publicidade-outdoor-led-800.webp'),
      icon: 'fas fa-ad',
      title: 'Publicidade e Comunicação Visual',
      description: 'Painéis de LED outdoor para fachadas, outdoors digitais e comunicação visual. Sua marca visível 24h por dia com alto impacto.',
      features: ['Outdoor digital de alta luminosidade', 'Operação 24/7', 'Gestão de conteúdo remoto'],
      alt: 'Painel de LED publicitário em fachada de edifício com anúncio luminoso noturno'
    }
  ];

  return (
    <section className="services" id="servicos">
      <div className="section-container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Nossos Serviços</span>
          <h2>Soluções em LED para <span>cada necessidade</span></h2>
          <p>De eventos a comunicação visual, oferecemos a solução em painéis de LED ideal para cada segmento.</p>
        </div>

        <div className="services__grid">
          {services.map((service, index) => (
            <div key={index} className="services__card glass-card" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="services__card-image">
                <img src={service.image} alt={service.alt} loading="lazy" width="800" height="500" />
                <div className="services__card-overlay">
                  <i className={service.icon}></i>
                </div>
              </div>
              <div className="services__card-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="services__features">
                  {service.features.map((feature, i) => (
                    <li key={i}>
                      <i className="fas fa-check"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceTypes;
